<template>
  <menu :class="className">
    <div class="navigation-side__content">
      <header class="navigation-side__header">
        <figure class="navigation-side__close" @click="$emit('close')">
          <svg-icon id="close" />
        </figure>
      </header>

      <nav class="navigation-side__list">
        <RouterLink
          v-for="({ label, ...link }, i) in links"
          :key="label"
          :to="link"
          :exact="!i"
          :style="{ transitionDelay: `${200 + (i * 50)}ms` }"
          class="navigation-side__item navigation-side__cascade-item"
          @click.native="$emit('close')">
          {{ label }}
        </RouterLink>
      </nav>
    </div>
  </menu>
</template>

<script>
export default {
  name: 'NavigationSide',
  props: {
    isOpen: { type: Boolean, default: false }
  },
  data() {
    return {
      links: [
        { name: 'home', label: 'Home' },
      ]
    }
  },
  computed: {
    className() {
      return ['navigation-side', { '-open': this.isOpen }]
    }
  }
}
</script>
